import { useCallback, useMemo } from 'react';
import { Navigate, type Messages, type ToolbarProps, type View } from 'react-big-calendar';

import { SessionScheduleToolbarLayout } from './session-schedule-calendar-toolbar-layout.js';

export function ToolbarWrapper({ label, view, views, onView, onNavigate, localizer: { messages } }: ToolbarProps) {
  const viewList = useMemo(() => (Array.isArray(views) ? views : []), [views]);
  const viewLabels = useMemo(() => {
    const labels: Record<string, string> = {};
    for (const viewName of viewList) {
      const message = messages[viewName as keyof Messages];
      labels[viewName] = typeof message === 'string' ? message : viewName;
    }
    return labels;
  }, [viewList, messages]);

  const jumpToPrevious = useCallback(() => onNavigate(Navigate.PREVIOUS), [onNavigate]);
  const jumpToNext = useCallback(() => onNavigate(Navigate.NEXT), [onNavigate]);
  const jumpToToday = useCallback(() => onNavigate(Navigate.TODAY), [onNavigate]);
  const handleViewChange = useCallback((newView: string) => onView(newView as View), [onView]);

  return (
    <SessionScheduleToolbarLayout
      label={label}
      view={view}
      views={viewList}
      viewLabels={viewLabels}
      onPrevious={jumpToPrevious}
      onNext={jumpToNext}
      onToday={jumpToToday}
      onViewChange={handleViewChange}
    />
  );
}
